import { useMutation, useQueryClient } from "@tanstack/react-query"
import { apiFetch } from "../framework/api"
import { useAuthToken } from "./useAuthToken"

export function useRunResortSnowReports(uid: string) {
  const token = useAuthToken()
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: () => apiFetch<{ Warning: string }>(
      `/admin/resorts/${encodeURIComponent(uid)}/snow-reports/run`,
      { token, method: "POST" },
    ),
    onSettled: () => queryClient.invalidateQueries({
      queryKey: ["resort-snow-reports", uid],
    }),
  })
}
